<template>
    <div class="dashboard-presentation-image h-100" :style="{ backgroundImage: 'url(\'' + imageUrl + '\')' }"></div>
</template>

<script>
    export default {
        name: "DashboardPresentationImage",

        props: {
            screenUid: {
                type: String,
                required: true,
            },
            screen: {
                type: Object,
                required: false,
            },
        },

        computed: {
            imageUrl() {
                if(this.screen.options && this.screen.options.imageUrl) {
                    return this.screen.options.imageUrl;
                }
                return "";
            },
        },
    }
</script>

<style lang="scss" scoped>
    .dashboard-presentation-image {
        background-color: black;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
    }
</style>
